/* unplugin-vue-components disabled */import script from "./HeaderBar.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderBar.vue?vue&type=script&setup=true&lang=js"

import "./HeaderBar.vue?vue&type=style&index=0&id=b1bc4b32&lang=less"

const __exports__ = script;

export default __exports__